// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false,
    refineByStyle: 'style2',
    filterTreeMobileStyle: 'style3',
    capitalizeFilterOptionValues: false,
    enableSeo: false,
    addCollectionToProductUrl: false
  },
};

var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;
var numberQuickViewModalLoaded = 0;
(function() {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  /************************** BUILD PRODUCT LIST **************************/

  //Object constructor to use a variant as data object. Creates a new data object by combining parent product data and variant data since not all required data is provided for variants
  /*dataObjFromVaraintConstructor = function(data, variant){
    //create image_info array
    let imgArr = []
    let imgObj = {}
    if(!!data.images_info[0]){
      imgObj = {
        "src": variant.image,
        "width": data.images_info[0].width,
        "alt": data.images_info[0].alt,
        "id": data.images_info[0].id,
        "position": data.images_info[0].position,
        "height": data.images_info[0].height
      };
    }
    
    if(!!imgObj){
      imgArr.push(imgObj)
    }
    // create obj with same syntax as data argument. Contains only properties used by boost app to render collections/search
    const variantDataObj = Object.assign({}, data, {
      images_info: imgArr,
      available: data.available,
      compare_at_price_min: variant.compare_at_price,
      price: variant.price,
      price_min: variant.price,
      price_max: variant.price,
      tags: data.tags, // we use parent product tags here to make shure freight costs still work correctly
      vendor: data.vendor,
      id: data.id,
      handle: data.handle,
      title: data.title + ' - ' + variant.option2,
    });

    return variantDataObj
  }*/
  
 ProductGridItem.prototype.compileTemplate = function(data, index) {
   if (!data) data = this.data;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    itemHtml = itemHtml.replace(/{{grid_item_width}}/g, boostPFSConfig.custom.grid_item_width);
    itemHtml = itemHtml.replace(/{{products_per_row}}/g, boostPFSConfig.custom.products_per_row);

    // Add Thumbnail
    var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : '';
    var paddingBottom = images.length > 0 ? 100 / aspectRatio : '100';
    var thumb = images.length > 0 ? images[0] : boostPFSConfig.general.no_image_url;
    var productGridImageFillClass = '';
    if(boostPFSConfig.custom.hasOwnProperty('product_grid_image_fill') && boostPFSConfig.custom.product_grid_image_fill){
      productGridImageFillClass = 'grid__image-contain';
    }
    var itemImagesHtml = '';
    if (boostPFSConfig.custom.product_grid_image_size == 'natural') {
      itemImagesHtml += '<div class="image-wrap" style="height: 0; padding-bottom: ' + paddingBottom + '%;">';
      itemImagesHtml += '<img ' +
                  'class="grid-product__image lazyload" ' +
                  'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
                  'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                  'data-aspectratio="' + aspectRatio + '" ' +
                  'data-sizes="auto" ' +
                  'alt="{{itemTitle}}">';
      itemImagesHtml += '<noscript>' +
                '<img class="grid-product__image lazyloaded" ' +
                'src="' + Utils.getFeaturedImage(images, '400x') + '" ' +
                'alt="{{itemTitle}">' +
              '</noscript>';
      itemImagesHtml += '</div>';

    } else {
      itemImagesHtml += '<div class="grid__image-ratio grid__image-ratio--' + boostPFSConfig.custom.product_grid_image_size + '" >';
      itemImagesHtml += '<img ' +
        'class="lazyload ' + productGridImageFillClass + '" ' +
        'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
        'data-widths="[360, 540, 720, 900, 1080]" ' +
        'data-aspectratio="' + aspectRatio + '" ' +
        'data-sizes="auto" ' +
        'alt="{{itemTitle}}">';
      itemImagesHtml += '</div>';
    }

    if (!soldOut) {
      if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
        itemImagesHtml += '<div class="grid-product__secondary-image small--hide">';
        itemImagesHtml += '<img class="lazyload"' +
          'data-src="' + Utils.optimizeImage(images[1].src, '{width}x') + '"' +
          'data-widths="[360, 540, 720, 900, 1080]"' +
          'data-aspectratio="' + aspectRatio + '"' +
          'data-sizes="auto"' +
          'alt="{{itemTitle}}">';
        itemImagesHtml += '</div>';
      }
    }

    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
    
    // Add Price
    var price_label = 'E-BIKE ONLY Preis';
    var itemPriceHtml = '';
    if (onSale) {
      price_label = boostPFSAppConfig.general.ebike_strike_price;
      var originalPrice = Utils.formatMoney(data.compare_at_price_min).replace('€', '');
      var euros = originalPrice.split(',')[0];
      var cents = originalPrice.split(',')[1];
      if (cents == '00') {
        originalPrice = originalPrice.replace(',00', ',-');
        cents = '';
      }
      else{
        originalPrice = euros;
      }
      //itemPriceHtml += '<span class="visually-hidden">' + boostPFSAppConfig.general.regular_price + '</span>';
      itemPriceHtml +=
        '<span class="grid-product__price--original eg_product_price__uvp--strike">' +
        originalPrice +
        '<span class="cents">' +
        cents +
        '</span>' +
        '</span>';
      //itemPriceHtml += '<span class="visually-hidden">' + boostPFSAppConfig.general.sale_price + '</span>';
    }
    if (priceVaries) {
     // itemPriceHtml += boostPFSAppConfig.general.from_text_html.replace(
     //   /{{ price }}/g,
     //   Utils.formatMoney(data.price_min).replace('€', '')
     // );
      itemPriceHtml += 'ab ' + Utils.formatMoney(data.price_min).replace('€', '').replace(',00', ',-');
    } else {
      if (Utils.formatMoney(data.price_min).split(',')[1].includes('00')) {
        itemPriceHtml +=
          '<span class="grid-product__price_label">' +
          price_label +
          '</span>' +
          '<span class="vendor_price">' +
          ' ' +
          Utils.formatMoney(data.price_min).replace('€', '').replace(',00', ',-').replace('.', '') +
          '</span>';
      } else {
        itemPriceHtml +=
          '<span class="grid-product__price_label">' +
          price_label +
          '</span>' +
          '<span class="vendor_price vendor_price-cents">' +
          ' ' +
          Utils.formatMoney(data.price_min).split(',')[0].replace('.', '') +
          '<span class="cents">' +
          Utils.formatMoney(data.price_min).split(',')[1].replace('€', '') +
          ' ' +
          '</span>' +
          '</span>';
      }
    }
    if (onSale && boostPFSAppConfig.general.product_save_amount) {
      var savePrice = '';
      if (boostPFSAppConfig.general.product_save_type == 'dollar') {
        savePrice = Utils.formatMoney(data.compare_at_price_min - data.price_min);
      } else {
        savePrice = Math.round(((data.compare_at_price_min - data.price_min) * 100) / data.compare_at_price_min);
        savePrice += '%';
      }

      var savePriceText = boostPFSAppConfig.general.save_html.replace(/{{ saved_amount }}/g, savePrice);
      savePriceText = savePriceText.replace('€', '');
      var euros = savePriceText.split(',')[0];
      var cents = savePriceText.split(',')[1];
      if (savePriceText.split(',')[1] == '00') {
        savePriceText = savePriceText.replace(',00', ',-');
        cents = '';
      }
      else{
        savePriceText = euros;
      }
      itemPriceHtml +=
        '<span class="grid-product__price--savings">' +
        savePriceText.replace('.', '') +
        '<span class="cents">' +
        cents +
        ' ' +
        '</span>' +
        '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    

    // Add soldOut class
    var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add label
    var customLabel = '';
    data.tags.forEach(function(tag) {
      if (tag.startsWith('_label_')) {
        if (!customLabel) {
          customLabel = tag.replace('_label_', '');
        }
      }
    });
    var itemLabelHtml = '';
    if (customLabel) {
      itemLabelHtml = '<div class="grid-product__tag grid-product__tag--custom">' + customLabel + '</div>';
    } else {
      // soldOut Label
      if (soldOut) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sold-out">' + boostPFSConfig.label.sold_out + '</div>';
      } else if (onSale) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sale">' + boostPFSConfig.label.sale + '</div>';
      }
    }
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);
    
    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Quick shop
    var itemQuickShopClass = '';
    var itemQuickShopButtonHtml = '';
    if (boostPFSConfig.custom.quick_shop_enable && !soldOut) {
      itemQuickShopClass = 'grid-product__has-quick-shop';
      itemQuickShopButtonHtml = '<div class="quick-product__btn js-modal-open-quick-modal-{{itemId}} small--hide ' + (isFirstLoad ? '' : 'bc-hide') + '" data-product-id="{{itemId}}">' +
        '<span class="quick-product__label">' + boostPFSConfig.label.quick_shop + '</span>' +
        '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
    itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);

    // Add Reviews
    if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
      var reviewHtml = '';
      if(boostPFSConfig.custom.enable_product_reviews) {
        reviewHtml = '<span class="shopify-product-reviews-badge" data-id="'+ data.id +'"></span>';
      }
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewHtml);
    }

    //Get freight costs and format to 99,- / 99??
    const result = data.tags.filter(freightTag =>
      freightTag.includes('frachtkosten')
      );

    if(!result){
      result = 0;
    }

    var freightCostsCents

    if(!!result && result.length > 0){
      freightCostsCents = result[0].replace("frachtkosten:", "");
      freightCostsCents = freightCostsCents/100
      var freightCosts = Utils.formatMoney(freightCostsCents);
      freightCostsFormatted = freightCosts.replace('€', '');
      
      var euros = freightCostsFormatted.split(',')[0];
      var cents = freightCostsFormatted.split(',')[1];
      if (freightCostsFormatted.split(',')[1] == '00') {
        freightCostsFormatted = freightCostsFormatted.replace(',00', ',-');
        cents = '';
      }
      else{
        freightCostsFormatted = '<span class="freight-price__euro">' + euros + '<span class="freight-price__cents">' + cents + '</span></span>';
      }
    }
    //Add tax and shipping label
    let freightInfo
    if (freightCostsCents > 0  ){
      freightInfo = boostPFSAppConfig.general.shipping_costs + freightCostsFormatted ;
    }else{
      freightInfo = boostPFSAppConfig.general.free_delivery};
      
    // Add tax and shipping info
    var taxandShippingHtml = '<small>' + boostPFSAppConfig.general.tax + '/' + freightInfo + '</small>';
    itemHtml = itemHtml.replace(/{{itemShippingAndTax}}/g, taxandShippingHtml);

    //adds availability dots
    let availabilityDotsArray = []
    let availabilityDotsMarkup = "";

    //set currentcolor for Elements without multiple colors
    if(!data.currentcolor){
      const currentID = data.variant_id
      let currentcolor
      data.variants.forEach(function(variant) {
        if(variant.id == currentID){
          currentcolor = variant.option_farbe
        }
      });
      if(!!currentcolor){
        data['currentcolor'] = currentcolor 
      }
    }

    //create one string with alle the availability markup
    data.variants.forEach(function(variant) {
      let availability = 'gray'
      //add availability from metafield to each variant
      data.metafields.forEach(function(metafield){
        if(variant.id === metafield.id){
          const metaValue = JSON.parse(metafield.value)
          if(!!metaValue.wert){
            availability = setAvailabilityColor(metaValue.wert)
          } else{
            availability = setAvailabilityColor(metaValue)
          }
          variant['dynamicAvailability'] = availability
        }
      })

        
      //check if there is more than one variant and match variants with color of current item
      if( data.variants.length == 1 || data.currentcolor == variant.option_farbe){
        if(variant.option_rahmenhhe){
          availabilityDotsElemet = `<span>${variant.option_rahmenhhe ? variant.option_rahmenhhe : ""}</span><span class="variant__availability variant__availability--${availability}"></span>`
          availabilityDotsArray.push(availabilityDotsElemet)
        }
        
      }
    })

    availabilityDotsMarkup = availabilityDotsArray.join(' | ')


    //add varinat id to url if item has matching color and is available
    let ProductItemUrl = Utils.buildProductItemUrl(data);
    // data.variants.every(function(variant) {
    //   if((variant.dynamicAvailability == 'green' || variant.dynamicAvailability == 'yellow') && !!data.URLExtension && data.currentcolor == variant.option_farbe ){
    //     ProductItemUrl += `?variant=${variant.id}` ;
    //     return false;
    //   }else{
    //     return true;
    //   }
    // });


    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{availability}}/g, availabilityDotsMarkup);
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, ProductItemUrl);
    

    return itemHtml;
  };

  function setAvailabilityColor(metafieldValue){
    let availabilityClass

    if (metafieldValue == 'ausverkauft'){
      availabilityClass = 'red';
    }  
    else if (metafieldValue == 'Liefertermin noch unbestimmt'){
      availabilityClass = 'red';
    }
    else if (metafieldValue == 'zukünftig lieferbar'){
      availabilityClass = 'yellow';
    }
    else if (metafieldValue == 'sofort oder in Kürze lieferbar'){
      availabilityClass = 'green';
    }
    else{
      availabilityClass = 'gray';
    }

    return availabilityClass
  }

  // Build Swatch
  function buildSwatch(data, _this) {
    var itemSwatchHtml = '';
    var itemSwatchHoverImagesHtml = '';
    if (boostPFSConfig.custom.collection_color_swatches) {
      var swatchItems = [];
      var swatchHoverImages = [];
      data.options_with_values.forEach(function(option, index) {
        var option_name = option.name.toLowerCase();
        if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1) {
          var option_index = index;
          var values = [];
          data.variants.forEach(function(variant) {
            var value = variant.merged_options[option_index].split(':')[1];
            if (values.indexOf(value) == -1) {
              values.push(value);
              var colorValueSlugify = Utils.slugify(value);
              var colorImage = Utils.optimizeImage(boostPFSAppConfig.general.asset_url.replace('boost-pfs.js', colorValueSlugify + '.png'), '50x');
              var variantImage = Utils.optimizeImage(variant.image, '400x');

              var swatchItem = '<a href="{{itemUrl}}?variant={{variantId}}" ' +
                'class="color-swatch color-swatch--small color-swatch--{{colorValueSlugify}} {{swatchClass}}" ' +
                'data-variant-id="{{variantId}}" ' +
                'data-variant-image="{{variantImage}}" ' +
                'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};"> ' +
                '</a>';

              swatchItem = swatchItem.replace(/{{variantId}}/g, variant.id);
              swatchItem = swatchItem.replace(/{{colorValueSlugify}}/g, colorValueSlugify);
              swatchItem = swatchItem.replace(/{{swatchClass}}/g, variant.image ? 'color-swatch--with-image' : '');
              swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
              swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);
              swatchItem = swatchItem.replace(/{{backgroundColor}}/g, colorValueSlugify.split('-').pop());

              var swatchHoverImage = '<div class="grid-product__color-image grid-product__color-image--' + variant.id + ' small--hide"></div>';

              swatchItems.push(swatchItem);
              swatchHoverImages.push(swatchHoverImage);
            }
          });
        }
      });
      if (swatchItems.length > 1) {
        itemSwatchHtml = ' <div class="grid-product__colors grid-product__colors--{{itemId}}" >' + swatchItems.join('') + '</div>';
        itemSwatchHoverImagesHtml = swatchHoverImages.join('');
      }
    }
    return {
      itemSwatch: itemSwatchHtml,
      itemSwatchHoverImages: itemSwatchHoverImagesHtml
    };
  }

  /************************** END BUILD PRODUCT LIST **************************/

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    var paginationHtml = '';
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {

      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
    return '';
  };

  /************************** BUILD TOOLBAR **************************/

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
    }
    return html;
  };

  /* buildExtraProductList */
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;

    // Hover color swatch
    onColorSwatchHover();
  };

  function onColorSwatchHover() {
    document.querySelectorAll('.color-swatch--with-image').forEach(swatch => {
      swatch.addEventListener('mouseenter', function() {
        var id = swatch.dataset.variantId;
        var image = swatch.dataset.variantImage;
        var el = document.querySelector('.grid-product__color-image--' + id);
        el.style.backgroundImage = 'url(' + image + ')';
        el.classList.add('is-active');
      });
      swatch.addEventListener('mouseleave', function() {
        var id = swatch.dataset.variantId;
        document.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
      });
    });
  }

  /* buildAdditionalElements */
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;

    // Call theme init function
    //wrap all javascript use theme in window.ready event to make sure theme init and register sections successfully
    jQ(document).ready(function() {
      if (typeof theme !== null && window.theme) {
        if(typeof AOS != 'undefined' && typeof AOS.refreshHard == 'function'){
          AOS.refreshHard();
        }
        // Setup page transition classes
        if (typeof theme.pageTransitions == 'function') {
          theme.pageTransitions();
        }

        // Quickview button: Use boost otp & otp style 3, disable add to cart

        // // Reload products inside each quick shop
        // if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
        if (window.$ && typeof $ == 'function') {
          $(window).off('popstate');
        }
      }

      if (isFirstLoad) {
        isFirstLoad = false;
      }

      jQ('.js-drawer-open-collection-filters').on('click', function() {
        jQ('.' + Class.filterOption).each(function() {
          var showMoreType = jQ(this).data('show-more-type');
          if (showMoreType && jQ(this).data('display-type') != 'range') {
            self.buildFilterShowMore(jQ(this).find('.' + Class.filterBlockContent), showMoreType);
          }
        });
      });
    });
    // Add modal container for quickview
    var isReinitQuickview = !isFirstLoad || Utils.isSearchPage() || Globals.queryParams.hasOwnProperty('_');
    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable && isReinitQuickview) {
      jQ('.boost-pfs-quick-shop-modal-container').html('');
      if (data.products.length > 0) {
        data.products.forEach(function(product){
          var quickUrl = Utils.buildProductItemUrl(product) + '?view=boost-pfs-quickview';
          jQ.ajax({url: quickUrl, success: function(result) {
            numberQuickViewModalLoaded++;
            jQ('.boost-pfs-quick-shop-modal-container').append(result);
            if (numberQuickViewModalLoaded == data.products.length) {
              theme.collapsibles.init();
              numberQuickViewModalLoaded = 0;
              jQ('.quick-product__btn').removeClass('bc-hide');
            }
          }});
        });
      }
    }

    // Build total products text
    var totalProductText = '';
    if (data.total_product == 1) {
      totalProductText = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
    } else {
      totalProductText = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
    }
    jQ('.boost-pfs-filter-total-product').html(totalProductText);

    // Build filter button text on mobile
    var numSelectedFilter = jQ('.boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label').length;
    if (numSelectedFilter) {
      jQ('.js-drawer-open-collection-filters').addClass('btn--tertiary-active');
      jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter + ' (' + numSelectedFilter + ')');
    } else {
      jQ('.js-drawer-open-collection-filters').removeClass('btn--tertiary-active');
      jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter);
    }
    theme.initQuickShop();

    jQ('.boost-pfs-filter-mobile-footer').on('click', function(e) { 
      e.preventDefault()
      jQ('.js-drawer-close').trigger('click'); 
    });
    
  };

  Utils.buildProductItemUrl = function(data, hasCollection){
    // Get url information
    var params = Utils.getWindowLocation().search.substring(1);
    var pathname = window.location.pathname;
    var elements = pathname.split('/');
  
    // Check if has locale
    var localeURLPart = "";
    var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
    if (Settings.getSettingValue('general.useShopifyRouteForMultiLanguageURL') && hasShopifyRoutes) {
      localeURLPart = Shopify.routes.root.replace(/\/$/, '');
    } else if (elements.indexOf(boostPFSAppConfig.general.current_locale) > -1) {
      localeURLPart = "/" + boostPFSAppConfig.general.current_locale;
    }
  
    // Get product handle
    var handle = typeof data === 'object' && data.hasOwnProperty('handle') ? data.handle : data;
    var hasCollection = typeof hasCollection !== 'undefined' ? hasCollection : Settings.getSettingValue('general.addCollectionToProductUrl');
    if (hasCollection) {
      // Homepage or Search page
      if (pathname == '/' || Utils.isSearchPage() || Utils.isVendorPage() || Utils.isTypePage()) {
        var preHandle = localeURLPart + '/collections/all/products/';
        return preHandle + handle;
  
        // Tag Page
      } else if (Utils.isTagPage()) {
        var preHandle = localeURLPart + '/collections/';
        var collectionHandleIndex = elements.indexOf("collections") + 1
        if (elements.length >= 4) return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
        return '/collections/all/products/' + handle;
      } else {
        // Google cache URL
        // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
        if (params.indexOf('cache:') > -1) {
          var collectionHandle = 'all';
          var temp = params.split('&')[0].split('?')[0].split('collections/');
          if (temp.length > 1) {
            if (temp[1].indexOf('/') > -1) {
              collectionHandle = temp[1].split('/')[0];
            } else {
              collectionHandle = temp[1];
            }
          }
          collectionHandle = collectionHandle.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, '');
          return '/collections/' + collectionHandle + '/products/' + handle;
        }
        var collectionHandleIndex = elements.indexOf("collections") + 1;
        var preHandle = localeURLPart + '/collections/';
        if (typeof elements[2] !== 'undefined') {
          // Build for collection pages
          if ((localeURLPart === '' && elements[1] === 'collections') || localeURLPart !== '') return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
          //Build for other pages, use collection/all
          return preHandle + 'all' + elements[collectionHandleIndex] + '/products/' + handle;
        }
        return window.location.pathname + '/products/' + handle;
      }
    }
    return localeURLPart + '/products/' + handle;
  };
  
})();
